import { UserRecentProjectsAndContestsResultAjax } from './user-recent-projects-and-contests.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    userRecentProjectsAndContests: UserRecentProjectsAndContestsResultAjax;
  }
}

export const userRecentProjectsAndContestsBackend = {
  fetch: () => ({
    endpoint: `navigation/recent-projects-and-contests.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-recent-projects-and-contests/user-recent-projects-and-contests.backend.ts